module.exports = __webpack_public_path__ + "03bf14d9d3607ebe6708b6df2e2f5f04.jpg";